import React, { useEffect } from "react";
import { PageContainer } from "@amzn/stencil-react-components/page";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { H1, Text } from "../../../../components/typography";
import { defaultTextColor } from "../../../../config/palette";
import { Button } from "@amzn/stencil-react-components/button";
import { CHECKLIST_URL } from "../../../../config/urls";
import { useNavigator } from "../../../../hooks/use-navigator";
import { useParams } from "react-router";
import * as adobeAnalytics from "../../../../utility/adobe-analytics";
export const BadgeResultRoute = () => {
  const [goToChecklist] = useNavigator(CHECKLIST_URL);

  const { applicationId } = useParams<{
    applicationId: string;
  }>();

  useEffect(() => {
    adobeAnalytics.addPageLoadMetric(window, applicationId, "badge/result", {
      referrer: adobeAnalytics.interpretReferrer(document.referrer),
    });
  }, [applicationId]);

  return (
    <>
      <PageContainer color={defaultTextColor}>
        <Col gridGap="1rem" alignItems="center">
          <H1>Completed</H1>
          <Text>The badge photo has been successfully submitted</Text>
          <Row>
            <Button onClick={goToChecklist}>Go to Checklist</Button>
          </Row>
        </Col>
      </PageContainer>
    </>
  );
};
